import Field from "@/components/Field";
import Form from "@/components/Form";
import { Textarea } from "@/components/ui/textarea";
import { Module } from "@/constants";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { EmailTypeFormValues } from "@/modules/email-types/hooks/useEmailTypeForm";
import { Save } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { EMAIL_TYPE_DESCRIPTION_MAX_LENGTH } from "../constants";
import AsyncButton from "@/components/AsyncButton";

interface EmailTypeEditorFormProps {
  form: UseFormReturn<EmailTypeFormValues>;
  isSubmitting: boolean;
  onSubmit: (values: EmailTypeFormValues) => void | Promise<void>;
}

export const EmailTypeEditorForm = ({
  form,
  isSubmitting,
  onSubmit,
}: EmailTypeEditorFormProps) => {
  const { t } = useTranslation();
  const { can_update } = useModulePermissions(Module.EmailTypes);

  return (
    <Form form={form} handleSubmit={onSubmit}>
      <Field
        name="description"
        label={`${t("emailTypes.fields.description")}:`}
        labelClassName="detail-field-label"
        className="gap-1"
        render={({ field }) => (
          <Textarea
            className="w-full"
            maxLength={EMAIL_TYPE_DESCRIPTION_MAX_LENGTH}
            rows={3}
            data-testid="email-types-description-input"
            {...field}
            value={field.value}
          />
        )}
      />
      {can_update ? (
        <div className="flex justify-end">
          <AsyncButton
            type="submit"
            label={t("common.save")}
            loadingLabel={t("common.saving")}
            data-testid="email-types-save-description-button"
            disabled={!form.formState.isDirty || isSubmitting}
            loading={isSubmitting}
            icon={<Save className="mr-2 h-5 w-5" />}
          />
        </div>
      ) : null}
    </Form>
  );
};
